'use strict';

var UserExclusionRulesDirective = function UserExclusionRulesDirective() {
  return {
    restrict: 'E',
    controller: 'UserExclusionRulesController',
    template: require('../templates/user-exclusion-rules.html'),
    link: function link($scope, element) {
      $scope.isValidationMessage = function () {
        var validationMessageCssDisplay = element.find('.jqx-grid-validation').css('display');
        return validationMessageCssDisplay && validationMessageCssDisplay !== 'none';
      };
    }
  };
};
UserExclusionRulesDirective.$inject = [];
module.exports = UserExclusionRulesDirective;